export const YOUTUBE_KEY_API = "AIzaSyC97p1alQnIY68Y0BXVNg2ef1sWzcwy1lA";
// AIzaSyDlJbYH_T0ADqFZObrxwvESkfAFAwNOpDI
export const OFFSET_LIVE_CHAT = 9;
export const YOUTUBE_VIDEO_API =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet&chart=mostPopular&maxResults=50&regionCode=IN&key=" +
  YOUTUBE_KEY_API;

export const YOUTUBE_SEARCH_API =
  "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";

export const YOUTUBE_VIDEO_API_ADD =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet&chart=mostPopular&maxResults=50&regionCode=US&key=" +
  YOUTUBE_KEY_API;
export const YOUTUBE_VIDEO_API_ADDED =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet&chart=mostPopular&maxResults=10&regionCode=IN&key=" +
  YOUTUBE_KEY_API;
export const YOUTUBE_VIDEO_API_ADDEDNEW =
  "https://youtube.googleapis.com/youtube/v3/videos?part=snippet&chart=mostPopular&maxResults=10&regionCode=US&key=" +
  YOUTUBE_KEY_API;
